function dealerPendingRequest() {

    let profileService = [
        {
            name: "Pending Request",
            icon: "Pending Request",
            logoName: "fee",
            // flag: "voucherRequired",
            displayService: "dealerPendingRequest",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/dealerPendingRequest",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "",
            },
        ];

        return dashboardArr;
    };

    const pendingRequest = () => {
        const profileArr = [
            {
                path: "/index/pendingRequest",
                name: "Pending Request",
                icon: "fee-master",
                logoName: "Pending_Req",
            },
        ];
        return profileArr;
    };

    let a = dashboard();
    let b = pendingRequest();

    profileService[0].items = [...a, ...b];

    return profileService;
}

export default dealerPendingRequest;
